import type { ChartType } from '@revelio/core';

import type { SnowflakeConfig } from '../PageConfigProvider/types/item';
import type { DataProviderChildren, DataProviderSet } from './types';
import { transformSnowflakeRows } from './utils/transform-snowflake-data';
import { useSnowflakeSavedQuery } from './utils/useSnowflakeSavedQuery';

type SnowflakeDataProviderProps = {
  config: SnowflakeConfig | null | undefined;
  chartType: ChartType;
  defaultColor?: string;
  children: DataProviderChildren<DataProviderSet>;
};

export function SnowflakeDataProvider({
  config,
  chartType,
  defaultColor,
  children,
}: SnowflakeDataProviderProps) {
  const { data, queryStatus, error, enabled } = useSnowflakeSavedQuery(config);

  const { dataSet, dataStatus } = transformSnowflakeRows({
    rows: data ?? [],
    chartType,
    status: queryStatus,
    enabled,
    defaultColor,
  });

  return children({
    data: dataSet ?? undefined,
    status: dataStatus,
    error,
  });
}
